import './Loader.scss';

interface Props {
  className?: string;
}

function Loader(props: Props) {
  return (
    <div className={'centered'}>
      <div className={`lds-ring ${props.className || 'lds-white'}`}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

Loader.defaultProps = {
  className: ''
};

export default Loader;
